/**
 * convert 相关 store
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';
import * as types from 'src/store/types';
import { EnumLifetimeType } from 'src/const/date';

export default {
  namespaced: true,

  state: {
    allLogList: [],
    campaignLogList: [],
    adgroupLogList: [],
    adLogList: [],
    end_time: '',
    start_time: '',
    lifetime: EnumLifetimeType.unchosen,
    conversion_stime: '',
    conversion_etime: '',
  },
  getters: {
    allLogList: state => state.allLogList || [],
    campaignLogList: state => state.campaignLogList || [],
    adgroupLogList: state => state.adgroupLogList || [],
    adLogList: state => state.adLogList || [],
    end_time: state => state.end_time,
    start_time: state => state.start_time,
    conversion_stime: state => state.conversion_stime,
    conversion_etime: state => state.conversion_etime,
  },
  mutations: {
    [types.SET_LOGLIST](state, data) {
      state.logList = data;
    },
    [types.SET_REQUESTPARAMS](state, data) {
      state.requestParams = data;
    },
    [types.SET_STARTTIME](state, data) {
      state.start_time = data;
    },
    [types.SET_ENDTIME](state, data) {
      state.end_time = data;
    },
    [types.SET_LIFETIME](state, data) {
      state.lifetime = data;
    },
    [types.SET_CONVERSIONSTARTTIME](state, data) {
      state.conversion_stime = data;
    },
    [types.SET_CONVERSIONENDTIME](state, data) {
      state.conversion_etime = data;
    },
  },


  actions: {
    // 获取广告组列表
    getLogList(store, data) { // 第一个参数必须写，，不然是整个对象
      return request.get(apis.toolbox.logs, data);
    },
  },
};
